import React from "react";

export default function SignUpSuccess() {
  return (
    <svg
      width="232"
      height="232"
      viewBox="0 0 232 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M201.739 116.004C201.739 68.6473 163.351 30.2627 116 30.2627C68.646 30.2627 30.2583 68.647 30.2583 116.004C30.2583 163.354 68.646 201.741 116 201.741C163.351 201.741 201.739 163.354 201.739 116.004Z"
          fill="#00BE9A"
        />
        <path
          d="M163.208 87.2761C161.19 82.0714 157.077 82.8929 152.62 83.776C149.958 84.3307 138.12 87.7959 119.39 107.547C111.617 115.744 106.489 122.278 103.113 127.262C101.051 124.73 98.6882 122.021 96.2071 119.539C88.5765 111.911 80.0671 106.672 79.7094 106.452C76.1384 104.269 71.4768 105.392 69.2876 108.96C67.1012 112.528 68.221 117.198 71.7864 119.389C71.8594 119.435 79.1667 123.953 85.4794 130.267C91.9173 136.706 97.7502 145.413 97.8076 145.497C99.2278 147.632 101.612 148.878 104.121 148.878C104.551 148.878 104.986 148.842 105.419 148.767C108.379 148.253 110.758 146.039 111.483 143.122C111.501 143.052 114.509 134.739 130.398 117.987C143.196 104.489 151.731 100.199 154.688 99.0094C154.716 99.0046 154.737 99.0025 154.775 98.9945C154.761 98.998 154.871 98.9472 155.049 98.867C155.557 98.6766 155.829 98.6037 155.844 98.5999C155.699 98.6361 155.623 98.6451 155.623 98.6451L155.618 98.6189C156.986 98.022 159.548 96.9198 159.604 96.8963C163.461 95.3117 164.715 91.1629 163.208 87.2761Z"
          fill="white"
        />
      </g>
      <circle
        cx="115.999"
        cy="116.001"
        r="89.383"
        stroke="#3FBFAD"
        strokeOpacity="0.8"
        strokeWidth="1.28889"
        strokeDasharray="8.59 8.59"
      />
      <circle
        cx="115.998"
        cy="116"
        r="93.67"
        transform="rotate(-5.77999 115.998 116)"
        stroke="#32BEA6"
        strokeOpacity="0.6"
        strokeWidth="1.28889"
        strokeDasharray="9.45 9.45"
      />
      <circle
        cx="116"
        cy="116"
        r="97.957"
        transform="rotate(11.2921 116 116)"
        stroke="#32BEA6"
        strokeOpacity="0.4"
        strokeWidth="1.28889"
        strokeDasharray="10.31 10.31"
      />
      <circle
        cx="115.997"
        cy="116"
        r="102.244"
        transform="rotate(-5.89023 115.997 116)"
        stroke="#32BEA6"
        strokeOpacity="0.3"
        strokeWidth="1.28889"
        strokeDasharray="11.17 11.17"
      />
      <circle
        cx="115.996"
        cy="115.999"
        r="106.531"
        stroke="#32BEA6"
        strokeOpacity="0.2"
        strokeWidth="1.28889"
        strokeDasharray="12.89 12.89"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="171.481"
            height="171.481"
            fill="white"
            transform="translate(30.2583 30.2607)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
